import React, { Component } from "react";

// Bliver ikke brugt pt
export class FstyrInputCpr extends Component {
  /*
    PROPS:
    
    onChange
    type
    infoHeader
    infoBody
    label
    showInfo
    */

  constructor(props) {
    super(props);

    this.state = {
      cprStart: "",
      cprEnd: "",
      input: "",

      emptyEnd: false,
    };
  }

  componentDidMount() {
    this.setState({
      input: "",
    });
  }

  setCprStart(input) {
    if (input.length === 10) {
      this.setState(
        {
          cprStart: input.substring(0, 6),
          cprEnd: input.substring(6, 10),
        },
        () => this.setInput()
      );
    } else {
      this.setState(
        {
          cprStart: input.length > 6 ? this.state.cprStart : input,
        },
        () => {
          if (this.state.cprStart.length === 6) {
            this.cprEndInput.focus();
          }
          this.setInput();
        }
      );
    }
  }

  setCprEnd(input) {
    this.setState(
      {
        cprEnd: input.length > 4 ? this.state.cprEnd : input,
      },
      () => {
        if (this.state.cprEnd.length === 0) {
          this.cprStartInput.focus();
        }
        this.setInput();
      }
    );
  }

  setInput() {
    this.setState(
      {
        input: this.state.cprStart + this.state.cprEnd,
      },
      () => this.props.onChange(this.state.input)
    );
  }

  handleNonCharKey(input, key) {
    if (input === "end") {
      if (key === "Backspace" && this.state.cprEnd.length === 0) {
        this.cprStartInput.focus();
      }
    }
  }

  handleKeyPress(e) {
    if (e.key === "Enter") {
      this.props.onEnterPressed();
    }
  }

  getType(type) {
    switch (type) {
      case "warning":
        return "alert alert-warning";
      case "error":
        return "alert alert-error";
      case "info":
        return "alert alert-info";
      case "success":
        return "alert alert-success";
      default:
        return "alert alert-info";
    }
  }

  alertBody() {
    return (
      <div className={this.getType(this.props.type)}>
        <div className="alert-body">
          <p className="alert-heading">{this.props.infoHeader}</p>
          <p className="alert-text">{this.props.infoBody}</p>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        <div className="form-group">
          <label className="form-label" htmlFor="input-antal">
            {this.props.label}
          </label>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div className="form-input-wrapper form-input-wrapper--suffix">
              <input
                className="form-input"
                id="input-antal"
                value={this.state.cprStart}
                name="input-antal"
                type="number"
                required
                style={{ width: "9rem" }}
                ref={(cprStartInput) => {
                  this.cprStartInput = cprStartInput;
                }}
                onChange={(e) => this.setCprStart(e.target.value)}
                onKeyDown={(e) => this.handleNonCharKey("start", e.key)}
                onKeyPress={(e) => this.handleKeyPress(e)}
              />

              <div style={{ borderRadius: "0px", borderRight: "none" }} className="form-input-suffix" aria-hidden="true">
                -
              </div>
            </div>
            <div className="form-input-wrapper form-input-wrapper--prefix">
              <input
                className="form-input input-char-4 fstyr-selectable"
                id="input-antal"
                value={this.state.cprEnd}
                name="input-antal"
                type="number"
                required
                ref={(cprEndInput) => {
                  this.cprEndInput = cprEndInput;
                }}
                onChange={(e) => this.setCprEnd(e.target.value)}
                onKeyDown={(e) => this.handleNonCharKey("end", e.key)}
                onKeyPress={(e) => this.handleKeyPress(e)}
              />
            </div>
          </div>
          {this.props.showInfo ? this.alertBody() : null}
        </div>
      </div>
    );
  }
}
